import { JetView } from 'webix-jet';
import { profile } from 'config/config';
import { devConfig } from 'config/config';

/**
 * Class representing the FilterLeaguesListView.
 * @extends JetView
 */
export default class FilterLeaguesListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form with filters
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'id',
                            type: 'number',
                            label: _("<span class='icon-id'></span> ID"), // ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'text',
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Name label
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder for Name input
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Activation status label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            value: '',
                            options: [
                                { id: '', value: _('Todo') }, // All option
                                { id: 'A', value: _('Activado') }, // Activated option
                                { id: 'C', value: _('Cancelado') }, // Canceled option
                                { id: 'I', value: _('Inactivado') }, // Inactivated option
                            ],
                        },
                    ],
                },
            ],
        };

        // Second left section of the form with additional filters
        const left2 = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Description label
                            labelPosition: 'top',
                            placeholder: _('Descripción'), // Placeholder for Description input
                        },
                        {
                            view: 'richselect',
                            name: 'TypeProduct',
                            label: _('Tipo de Producto'), // Product type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            value: '',
                            options: [], // Options for product type
                        },
                        {
                            view: 'text',
                            name: 'DateStart',
                            id: 'DateStart',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Inicio'), // Start date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for start date input
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'DateEnd',
                            id: 'DateEnd',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Fin'), // End date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for end date input
                        },
                        {
                            view: 'richselect',
                            name: 'Partner',
                            label: _('Partner'), // Partner label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            value: profile.PartnerSelected, // Default selected partner
                            options: profile.Partners, // Partner options from profile
                            id: 'Partners',
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section of the form
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 190 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section included
                },
            ],
        };

        // Second upper section of the form
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 320 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Second left section included
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Second upper section included
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            margin: 2,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Liga'), // Add League button
                    type: 'form',
                    width: 120,
                    hidden: !devConfig.getPermAction('leaguesListAdd', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-leaguesListAdd',
                    click: () => {
                        this.show('leagues.addLeagueManagement/leagues.AddLeague'); // Navigate to add league view
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    width: 66,
                    click: () => {
                        this.getRoot().clear(); // Clear form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    width: 84,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('agentList:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, accordion_section, buttons], // Main layout structure
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
